// src/router/index.js
import { createRouter, createWebHashHistory } from 'vue-router';
const routes = [
    {
      path: '/',
      name: 'home',
      component: () => import('@/view/index/index.vue'),
      children: [
        {
          path: '',
          name: 'home-content',
          component: () => import('@/view/HomeContent/index.vue'),
        },
        {
          path: 'price',
          name: 'price',
          component: () => import('@/view/price/index.vue'),
        },
        {
          path: 'priceDetail',
          name: 'priceDetail',
          component: () => import('@/view/price/pricedetail.vue'),
        },
        {
          path: 'freight',
          name: 'freight',
          component: () => import('@/view/FreightContent/index.vue'),
        },
        {
          path: 'software',
          name: 'software',
          component: () => import('@/view/SoftwareContent/index.vue'),
        },
        {
          path: 'orders',
          name: 'orders',
          component: () => import('@/view/OrdersContent/index.vue'),
        },
        {
          path: 'login',
          name: 'login',
          component: () => import('@/view/login/index.vue'),
        },
        {
          path: 'register',
          name: 'register',
          component: () => import('@/view/register/index.vue'),
        }
        ,
        {
          path: 'forget',
          name: 'forget',
          component: () => import('@/view/forget/index.vue'),
        },{
          path:'mycenter',
          name:'mycenter',
          component: () => import('@/view/mycenter/index.vue'),
        },
        {
          path: 'vip',
          name: 'vip',
          component: () => import('@/view/vip/index.vue'),
        }
       
       
      ],
    },
];
const router = createRouter({
 history: createWebHashHistory(),
 routes,
});
export default router;